import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsEventsCalendarCalendarEventsItemCls: string;
		}
	},

	slug: string
}

class Calendar extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Events Calendar Calendar Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();

		if(this.publicVars.cssId?.anim?.investorsEventsCalendarCalendarEventsItemCls) {
			const eventsCount = document.querySelectorAll(
				this.publicVars.cssId?.anim?.investorsEventsCalendarCalendarEventsItemCls).length;

			for(let i = 1; i <= eventsCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsEventsCalendarCalendarEventsItemCls + i, 'investors_events_calendar_calendar', { animCls: 'animate__zoomIn', once: true});
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default Calendar;